module.exports = __webpack_public_path__ + "img/urletul.e2a36de7.jpg";